import React, { useEffect } from "react";
import { Box, Stack, Chip, Button, IconButton, Grid, Typography, useTheme, Tooltip, TextField, FormGroup, FormControlLabel, Switch, Tab, Tabs, Badge } from "@mui/material";
import Divider from '@mui/material/Divider';
import { useQuery } from "@tanstack/react-query";
import { useLocalStorage } from "../../hooks/useLocalStorage";
//Hooks
import { getReturns, patchReturn, deliverReturnOrderRow, getReturn, cancelReturn, closeReturnOrder } from "../../hooks/returns.jsx";
import { getManufacturers } from "../../hooks/manufacturers.jsx";
import { getDrumQualities } from "../../hooks/drumQualities.jsx";
import { getReeltypes } from "../../hooks/reeltypes.jsx";
import { getArticles } from "../../hooks/articles";
import { getRejectedReasons } from "../../hooks/rejectedReasons";
//Controls
import Controls from "../../components/controls/Contols";
import AxionConfirmation from '../../components/controls/AxionConfirmation';
//Icons
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import SaveIcon from '@mui/icons-material/Save';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
//Components
import BookingInformation from "./components/BookingInformation";
import PickupDetails from "./components/PickupDetails";
import OrderList from "./components/OrderList";
import DrumList from "./components/DrumList";
import CustomerInformation from "./components/CustomerInformation";

import { styled } from '@mui/material/styles';
import { tokens } from "../../assets/theme";
import { useState } from "react";
import dayjs from "dayjs";
import { DriveFileMove } from "@mui/icons-material";
import { pushErrorMessage, pushNotification } from "../../utils/notifications";
import { v4 as uuidv4 } from 'uuid';
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";

const ReturnsIndex = () => {

    //Set instance
    //const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);
    const [instanceCountry, setInstanceCountry] = useLocalStorage("instanceCountry", "SV");
    

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    const returnsQuery = useQuery(
        ["returns"],
        () => getReturns(),
        {}
    );

    const manufacturersQuery = useQuery(
        ["manufacturers"],
        () => getManufacturers(),
        {}
    );

    const drumQualitiesQuerty = useQuery(
        ["drumqualities"],
        () => getDrumQualities(),
        {}
    );

    const reeltypesQuery = useQuery(
        ["reeltypes"],
        () => getReeltypes(),
        {}
    );

    const articlesQuery = useQuery(
        ["articles"],
        () => getArticles(),
        {}
    );

    const rejectedReasonsQuery = useQuery(
        ["rejectedReasons"],
        () => getRejectedReasons(),
        {}
    );

    const states = [1, 2, 3, 4, 9, 10];
    const stateNames = ["Regitered", "In progress", "Pick up", "Paid", "Ready", "Cancelled"];
    const statesCount = [];
    const [filteredData, setfilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [showChildrenFor, setShowChildrenFor] = useState(0);
    const [showOrder, setShowOrder] = useState(null);
    const [slim, toggleSlim] = useState(false);
    const [sortBy, setSortBy] = useLocalStorage("drumster-listsorting", []);//useState("customer");
    const [distinctCustomers, setDistinctCustomers] = useState([]);
    const [distinctTransporters, setDistinctTransporters] = useState([]);
    const [distinctReturnpoints, setDistinctReturnpoints] = useState([]);
    const [customerFilter, setCustomerFilter] = useState("");
    const [transporterFilter, setTransporterFilter] = useState("");
    const [returnpointFilter, setReturnpointFilter] = useState("");
    const [showHidden, setShowHidden] = useState(false);
    const [showCustomer, setShowCustomer] = useState(null);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [articleList, setArticleList] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [confirmationTitle, setConfirmationTitle] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState("");

    useEffect(() => {

        console.log("Resetting showOrder", showOrder);
        doFilter(stateValue, searchValue, customerFilter, transporterFilter, returnpointFilter, sortBy);

        if (showOrder !== null) {
            let showOrderId = showOrder.id;
            handleShowOrder(showOrder);
        }

    }, [returnsQuery.data]);

    const addFreightCost = (value) => {
        let costDrum = showOrder?.returndrums?.filter(x => x.article.id === 125);
        let cost = costDrum[0]?.drumcount;
        costDrum[0].drumcount = cost + value;
        let pd = showOrder?.pickupdata
        pd.freightCost = cost + value;

        setShowOrder({ ...showOrder, returnDrums: showOrder?.returndrums, pickupdata: pd });
    }

    const handleChange = (event) => {
        const { id, name, value, type, checked } = event.target

        //console.log("handleChange", id, name, value, type, checked, event.target);

        setShowOrder(prev => {
            //Hierarchical (2 level) state update
            if (id.includes(".")) {
                let [parent, child] = id.split(".");
                return {
                    ...prev,
                    [parent]: {
                        ...prev[parent],
                        [child]: type === "checkbox" ? checked : value
                    }
                }
            }
            //Simple state update
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : value
            }
        })
    }

    const handleChangeSetValue = (event) => {
        const { id, name, value, type, checked } = event.target

        setShowOrder(prev => {
            //Hierarchical (2 level) state update
            if (id.includes(".")) {
                let [parent, child] = id.split(".");
                return {
                    ...prev,
                    [parent]: {
                        ...prev[parent],
                        [child]: value
                    }
                }
            }
            //Simple state update
            return {
                ...prev,
                [id ? id : name]: value
            }
        })
    }

    const handleRowChange = (index, event, field) => {
        //let data = [...props.data];
        let data = { ...showOrder };

        //console.log ("zzzhandleRowChange", index, event.target, field);
        let value = event.target.value;
        if (field === "reeltypeid") {

            let oldDrum = { ...data.returndrums[index] };

            let newDrum = {
                ...data.returndrums[index],
                articleId: value,
                article: articlesQuery.data?.find(x => x.id === value),
                drumcount: oldDrum.drumcount,
                id: null,
                createdTs: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                manufacturerid: null, drumqualityid: null, reeltypeid: null,
                //fromDb: false
            };
            data.returndrums.push(newDrum);

            //Set old drum to 0 qty
            data.returndrums[index].drumcount = 0;

            //console.log("zzzdata.returndrums", data.returndrums);
        }
        if (field === "drumqualityid") {
            let oldDrum = { ...data.returndrums[index] };


            let newDrum = {
                ...data.returndrums[index],
                //articleId: newArticle.id,
                //article: newArticle, //articlesQuery.data?.find(x => x.id === value),
                drumcount: oldDrum.drumcount,
                id: null,
                createdTs: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                manufacturerid: oldDrum.manufacturerid,
                drumqualityid: value,
                reeltypeid: null,
                //fromDb: false
            };
            //console.log ("zzznewDrum", newDrum);
            data.returndrums.push(newDrum);

            //Set old drum to 0 qty
            data.returndrums[index].drumcount = 0;

            //console.log("After:",{...data.returndrums});


            //####
            //data.returndrums[index].drumqualityid = value;
        }
        if (field === "manufacturerid") {
            data.returndrums[index].manufacturerid = value;
        }
        if (field === "drumcount") {

            if (value !== "") {
                data.returndrums[index].drumcount = value;
            } else {
                data.returndrums[index].drumcount = null;
            }

        }
        if (field === "rejectedReasonId") {
            data.returndrums[index].rejectedReasonId = value;
        }

        //remove returndrums with drumcount = 0 and fromDb = false
        data.returndrums = data.returndrums.filter(x => !(x.drumcount === 0 && x.id === null));

        setShowOrder(data);
    }

    const handleDeleteRow = (index, event) => {
        let data = { ...showOrder };
        data.returndrums[index].drumcount = 0;
        data.returndrums[index].drumQualityId = null;

        setShowOrder(data);
    }

    const handleAddRow = (newItem) => {
        let data = { ...showOrder };

        let newDrum = {
            articleId: newItem.articleId,
            article: articlesQuery.data?.find(x => x.id === newItem.articleId),
            drumcount: newItem.itemCount,
            id: null,
            createdTs: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
            manufacturerid: newItem.manufacturerId,
            drumqualityid: newItem.qualityId,
            reeltypeid: null,
            fromDb: false,
            attachments: []
        };
        data.returndrums.push(newDrum);

        // data.returndrums = data.returndrums.filter(x => !(x.drumcount === 0 && x.id === null));

        setShowOrder(data);
    }

    const handleDeliverRow = (index, event) => {
        let row = {
            id: showOrder.returnid,
            articleId: showOrder.returndrums[index].article.id,
            drumQualityId: showOrder.returndrums[index].drumqualityid,
            drumcount: showOrder.returndrums[index].drumcount,
            drumRowId: showOrder.returndrums[index].id,
            itemNo: "123"
        };

        //Update order, then deliver row
        setShowSpinner(true);
        patchReturn(showOrder).then((result) => {
            //console.log("Save order ok:", result);
            pushNotification("Order updated in Return system");

            deliverReturnOrderRow(row).then((result) => {
                //console.log("deliverReturnOrderRow Result: ", result);
                pushNotification("Row delivered to Pyramid");
                handleShowOrder(showOrder);

                //   setShowOrder(result);
            }).catch((error) => {
                console.log(error);
                pushErrorMessage("Problem delivering row in Pyramid. " + error?.response?.data?.message);
            });

            returnsQuery.refetch();
            //handleShowOrder(showOrder);
            //console.log("Save order done!");
            setShowSpinner(false);
        }).catch((error) => {
            pushErrorMessage("Problem updating order in ReturnSystem: " + error?.response?.data?.message);
            setShowSpinner(false);
        });
    }

    function isMarkable(drum) {
        if (drum.locked === 1) { return false; }

        //Plastic
        if (drum.article?.material === 'P' && drum?.article?.articleType === 'SPL') { // && (drum.id === null || (drum.article?.visibleForSupplier === true && drum.drumqualityid === null))) {
            if (drum.id === null) { return false; }
            if (drum.article?.visibleForSupplier === true && drum.drumqualityid === 1 ) { return false; }
            if (drum.drumqualityid === null) { return false; }
        }
        //Wood
        if (drum.article?.material === 'W' && drum?.article?.articleType === 'STL') {// && (drum.id === null || drum.drumqualityid === null)) {
            if (drum.id === null) { return false; }
            if (drum.drumqualityid === null) { return false; }
        }
        //Other
        if (drum.article?.material === 'O') {  // && (drum.id === null || drum.drumqualityid === null)
            if (drum.id === null) { return false; }
        }
        return true;
    }


    const deliverRecursively = (index) => {
        if (index < showOrder.returndrums.length) {
            if (showOrder.returndrums[index].drumcount > 0) {
                if (isMarkable(showOrder.returndrums[index]) && showOrder.returndrums[index].locked === 0) {
                    let drum = {
                        id: showOrder.returnid,
                        articleId: showOrder.returndrums[index].article.id,
                        drumQualityId: showOrder.returndrums[index].drumqualityid,
                        drumcount: showOrder.returndrums[index].drumcount,
                        drumRowId: showOrder.returndrums[index].id,
                        itemNo: showOrder.returndrums[index].article.itemNo
                    };
                    deliverReturnOrderRow(drum).then((result) => {
                        //pushNotification("Row delivered to Pyramid", drum);

                        deliverRecursively(index + 1);
                    }).catch((error) => {
                        console.log(error?.response?.data?.message);
                        pushErrorMessage("Problem delivering row in Pyramid. " + error?.response?.data?.message);
                        deliverRecursively(index + 1);
                    });
                } else {
                    //console.log("Row not deliverable", isMarkable(showOrder.returndrums[index]), showOrder.returndrums[index].locked);
                    deliverRecursively(index + 1);
                }
            } else {
                deliverRecursively(index + 1);
            }
            
        } else {
            handleShowOrder(showOrder);
        }
    }

    const handleDeliverReadyRows = () => {
        setShowSpinner(true);

        patchReturn(showOrder).then((result) => {
            console.log("Save order ok:", result);
            pushNotification("Order updated in Return system");

            //Deliver all rows
            deliverRecursively(0);
            //returnsQuery.refetch();
            handleShowOrder(showOrder);
            console.log("Save order done!");
            setShowSpinner(false);
        }).catch((error) => {
            pushErrorMessage("Problem updating order in ReturnSystem: " + error);
            setShowSpinner(false);
        });
    }

    const handleCloseOrder = async () => {
        setShowSpinner(true);
        closeReturnOrder(showOrder.returnid).then((result) => {
            if (result.status === true) {
                pushNotification("Order closed", "The order has been closed", "success");
                returnsQuery.refetch();
                handleShowOrder(showOrder);
            } else {
                pushErrorMessage("Error", "The order could not be closed");
                console.log("Error closing order", result.message);
            }
        }).catch((error) => {
            console.log(error?.response?.data?.message);
            pushErrorMessage("Problem closing order in Pyramid. " + error?.response?.data?.message);
        });
        
        //setfilteredData(filteredData);
        //doFilter(stateValue, searchValue, customerFilter, transporterFilter, returnpointFilter, sortBy);
        setShowSpinner(false);
    }

    function splitRow(index) {
        const order = { ...showOrder };
        const drum = order.returndrums[index];
        let nrOfDrumsToAdd = order.returndrums[index].drumcount - 1;
        order.returndrums[index].drumcount = 1;
        for (let i = 0; i < nrOfDrumsToAdd - 1; i++) {
            const newDrum = { ...drum, id: null, drumcount: 1 };
            order.returndrums.splice(index + 1, 0, newDrum);
        }
        const newDrum = { ...drum, id: null, drumcount: 1 };
        order.returndrums.splice(index + 1, 0, newDrum);
        setShowOrder(order);
    }

    function getDistinctValues(data, key) {
        let result = [];
        data.forEach(element => {
            if (!result.includes(element[key])) {
                result.push(element[key]);
            }
        });
        return result;
    }

    function getDistinctCustomers(data) {
        let result = [];
        let customer = "";
        data.forEach(element => {
            customer = element.customer.customername;
            if (!result.includes(customer)) {
                result.push(customer);
            }
        });
        return result;
    }

    function getDistinctTransporters(data) {
        let result = [];
        let transporter = "";
        data.forEach(element => {
            transporter = element.pickupdata?.transportCompany?.name;
            if (!result.includes(transporter) && transporter !== null && transporter !== undefined) {
                result.push(transporter);
            }
        });
        return result;
    }

    function getDistinctReturnpoints(data) {
        let result = [];
        let returnpoint = "";
        data.forEach(element => {
            returnpoint = element.returnpoint.pointname;
            if (!result.includes(returnpoint) && returnpoint !== null && returnpoint !== undefined) {
                result.push(returnpoint);
            }
        });
        return result;
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const StyledTabs = styled((props) => (


        <Tabs
            {...props}
            TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
        />
    ))({
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
        },
        '& .MuiTabs-indicatorSpan': {
            maxWidth: 40,
            width: '100%',
            backgroundColor: colors.dashbordGreen[500]//'#799c4a',  //Small marking line at bottom of tab
        },
    });

    const StyledTab = styled((props) => <Tab disableRipple {...props} />)(

        ({ theme }) => ({

            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(20),
            marginRight: theme.spacing(1),
            //backgroundColor: '#799c4a',
            color: 'rgba(255, 255, 255, 0.7)',
            '&.Mui-selected': {
                color: '#040509',//'#fff',
                backgroundColor: "#d0d1d5 !important",//"#434957 !important",
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(100, 95, 228, 0.32)',
            },
            '&.MuiTab-root': {
                backgroundColor: colors.primary[700],//'#0c101b',  //Not selected Tab color
                borderTopLeftRadius: '5px',
                borderTopRightRadius: '5px',
            },
        }),
    );

    const sortByCustomer = () => {
        if (sortBy === "customer") {
            setSortBy("");
            doFilter(stateValue, searchValue, "", "", "", "");
        } else {
            setSortBy("customer");
            doFilter(stateValue, searchValue, "", "", "", "customer");
        }
    }

    const sortByTransporter = () => {

        if (sortBy === "transporter") {
            setTransporterFilter("");
            setDistinctTransporters([]);
            setSortBy("");
            doFilter(stateValue, searchValue, "", "", "", "");
        } else {
            setSortBy("transporter");
            doFilter(stateValue, searchValue, "", "", "", "transporter");
        }
    }

    const sortByReturnpoint = () => {
        if (sortBy === "returnpoint") {
            // setReturnpointFilter("");
            setDistinctReturnpoints([]);
            setSortBy("");
            doFilter(stateValue, searchValue, "", "", "", "");
        } else {
            setSortBy("returnpoint");
            doFilter(stateValue, searchValue, "", "", "", "returnpoint");
        }
    }

    const clearAllFilters = () => {
        setCustomerFilter("");
        setTransporterFilter("");
        setReturnpointFilter("");
        setDistinctReturnpoints([]);
        setDistinctTransporters([]);
        setDistinctCustomers([]);
        setSortBy(null);

        setShowOrder(null);
    }

    const filterByCustomer = (customer) => {
        setCustomerFilter(customer);
        setTransporterFilter("");
        setReturnpointFilter("");
        doFilter(stateValue, searchValue, customer, "", "", sortBy);
    }
    const filterByTransporter = (transporter) => {
        setTransporterFilter(transporter);
        setCustomerFilter("");
        setReturnpointFilter("");
        doFilter(stateValue, searchValue, "", transporter, "", sortBy);
    }
    const filterByReturnpoint = (returnpoint) => {
        setReturnpointFilter(returnpoint);
        setCustomerFilter("");
        setTransporterFilter("");
        doFilter(stateValue, searchValue, "", "", returnpoint, sortBy);
    }


    

    const handleShowCustomer = (customer) => {
        setShowCustomer(customer);
    }

    const handleShowOrder = (order) => {
        getReturn(order.id).then((result) => {
            //console.log("zzzhandleShowOrder Result", order);
            setShowOrder(result);

            setShowCustomer(result.customer);

            if (result === null) {
                toggleSlim(false);
            } else {
                toggleSlim(true);

                result.returndrums.forEach(drum => {
                    drum.rowKey = uuidv4();
                });
                setStateValue(result.statusid);
                setShowOrder(result);
            }

        }).catch((error) => {
            console.log(error);
        });
    }

    const handleShowChildrenClick = (id) => {
        if (id === showChildrenFor) {
            id = 0;
        }
        setShowChildrenFor(id);
    }

    const handleFilterState = (state) => {
        //console.log("Filtering", state);

        // Handle fake state 999
        if (state > 100) {
            setStateValue(state);
            return true
        }

        if (state === stateValue) {
            setStateValue("");
            doFilter("", searchValue, "", "", "", sortBy);
        } else {
            setStateValue(state);
            doFilter(state, searchValue, "", "", "", sortBy);
        }

        // In progress => preselect Drum tab
        if (state === 2 || state === 10) {
            setSelectedTab(1);
        }
        // Registered or Booked => preselect Order tab
        if (state === 1 || state === 3) {
            setSelectedTab(0);
        }
        // Ready or Paid => preselect customer tab
        if (state === 4 || state === 9) {
            setSelectedTab(2);
        }
        setShowOrder(null);
    }

    const doFilter = (state, search, customer, transporter, pickuppoint, sortBy) => {
        toggleSlim(false);

        let mainResult = returnsQuery.data;

        if (mainResult === null || mainResult === undefined || mainResult.length === 0) {
            //console.log("doFilter: No data", mainResult);
            return [];
        }

        if (state !== "") {
            mainResult = mainResult.filter(x => x.statusid === state);
        } else {
            mainResult = mainResult.filter(x => x.statusid !== 10); // Hide cancelled orders. Should only be shown in the list when filter is set to show cancelled orders
        }
        if (search !== "") {
            mainResult = searchFilterList(mainResult, search);
        }
        let result = mainResult;
        if (customer !== "") {
            result = result.filter(x => x.customer.customername === customer);
        }
        if (transporter !== "") {
            result = result.filter(x => x.pickupdata?.transportCompany?.name === transporter);
        }
        if (pickuppoint !== "") {
            result = result.filter(x => x.returnpoint.pointname === pickuppoint);
        }

        if (sortBy === "customer") {
            result.sort((a, b) => (a.customer.id > b.customer.id) ? 1 : -1);
            result.sort((a, b) => (a.customer.customername > b.customer.customername) ? 1 : -1);
            setDistinctTransporters([]);
            setDistinctCustomers([]);
            setDistinctReturnpoints([]);
        }
        if (sortBy === "transporter") {
            result.sort((a, b) => (a.pickupdata?.transportCompany?.name > b.pickupdata?.transportCompany?.name) ? 1 : -1);
            mainResult.sort((a, b) => (a.pickupdata?.transportCompany?.name > b.pickupdata?.transportCompany?.name) ? 1 : -1);
            let distinctTransporters = getDistinctTransporters(mainResult);
            setDistinctTransporters(distinctTransporters);
            setDistinctCustomers([]);
            setDistinctReturnpoints([]);
        }
        if (sortBy === "returnpoint") {
            result.sort((a, b) => (a.returnpoint.pointname > b.returnpoint.pointname) ? 1 : -1);
            mainResult.sort((a, b) => (a.returnpoint.pointname > b.returnpoint.pointname) ? 1 : -1);
            let distinctReturnpoints = getDistinctReturnpoints(mainResult);
            setDistinctReturnpoints(distinctReturnpoints);
            setDistinctTransporters([]);
            setDistinctCustomers([]);
        }

        //console.log("doFilter", result);

        setfilteredData(result);

        //if(filterByCustomer !== "") {setDistinctCustomers(getDistinctCustomers(result))};

        return result;
    }

    const clearSearchValue = () => {
        setSearchValue("");
        doFilter(stateValue, "", "", "", "", "");
    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
        doFilter(stateValue, event.target.value, "", "", "", sortBy);
    }

    const handleSaveOrderClick = () => {
        //console.log("Save order!");
        setShowSpinner(true);

        patchReturn(showOrder).then((result) => {
            console.log("Save order ok:", result);
            pushNotification("Order updated in Return system");
            returnsQuery.refetch();
            console.log("Save order done!");
            setShowSpinner(false);
        }).catch((error) => {
            pushErrorMessage("Problem updating order in ReturnSystem: " + error?.response?.data?.message);
            setShowSpinner(false);
        });


        //doFilter(stateValue, searchValue, customerFilter, transporterFilter, returnpointFilter, sortBy);
    };

    const handleCancelOrderClick = () => {
        console.log("cancel order!");
        if (showOrder.statusid < 2) {
            setShowSpinner(true);
            setOpenConfirmation(false);
            cancelReturn(showOrder.id).then((result) => {

                pushNotification("Order updated in Return system");
                returnsQuery.refetch();
                console.log("Save order done!");
                setShowSpinner(false);
                setStateValue(10);
            }).catch((error) => {
                console.log(error);
                pushErrorMessage("Problem updating order in ReturnSystem. " + error?.response?.data?.message);
                setShowSpinner(false);
                setOpenConfirmation(false);
            });
        }

        //doFilter(stateValue, searchValue, customerFilter, transporterFilter, returnpointFilter, sortBy);
    };

    const openCancelOrderDialogClick = () => {
        setOpenConfirmation(true);
        setConfirmationTitle("Cancel order");
        setConfirmationMessage("Are you sure you want to cancel this order?");
    }

    const cancelCancelOrderClick = () => {
        setOpenConfirmation(false);
        setConfirmationTitle("");
        setConfirmationMessage("");

    }

    function searchObjectsWithValue(dataRow, value) {

        if (dataRow === null || dataRow === undefined) {
            return false;
        }

        value = value.toLowerCase().trim();
        let done = false;

        //Remeber!!! 
        // .toLowerCase() for strings
        // .toString() for numbers

        // console.log("data:", dataRow, value);

        if (dataRow.customer.customername?.toLowerCase().includes(value)) { return true; }
        if (dataRow.customerid?.toString().includes(value)) { return true; }
        if (dataRow.returnid?.toString().includes(value)) { return true; }
        if (dataRow.id?.toString().includes(value)) { return true; }
        if (dataRow.pyramidOrderno?.toString().includes(value)) { return true; }
        if (dataRow.returnpoint.pointname?.toLowerCase().includes(value)) { return true; }
        if (dataRow.pickupdata?.location?.toLowerCase().includes(value)) { return true; }
        if (dataRow.pickupdata?.transportCompany?.name?.toLowerCase().includes(value)) { return true; }

        //console.log("Searched")


        // dataRow.returndrums?.forEach(drum => {
        //     if (drum.reeltype?.reeltype1?.toLowerCase().includes(value)) { done = true; }
        // });
        // if (done === true) { return true; }

        return false;
    }

    function searchFilterList(data, value) {
        let result = [];
        if (data === null || data === undefined) {
            return result;
        }

        //console.log("searchFilterList", data.length);
        result = data.filter(dataRow => {
            return searchObjectsWithValue(dataRow, value);
        });
        return result;
    }

    function getStatusText(status) {
        let statusText = "";
        switch (status) {
            case 1:
                statusText = formatMessage(messages.general_status1);
                break;
            case 2:
                statusText = formatMessage(messages.general_status2);
                break;
            case 999:
                statusText = formatMessage(messages.general_status999);
                break;
            case 3:
                statusText = formatMessage(messages.general_status3);
                break;
            case 4:
                statusText = formatMessage(messages.general_status4);
                break;
            case 9:
                statusText = formatMessage(messages.general_status9);
                break;
            case 10:
                statusText = formatMessage(messages.general_status10);
                break;
            default:
                statusText = formatMessage(messages.general_statusDefault);
                break;
        }

        return statusText;
    }

    function getBGColor(status) {
        let color = "";

        switch (status) {
            case 1:
                color = "#ffeb3b"; //yellow
                break;
            case 2:
                color = "#009688"; //teal
                break;
            case 999:
                color = "#ff9800"; //orange
                break;
            case 3:
                color = "#ff9800"; //orange
                break;
            case 4:
                color = "#4caf50"; //green
                break;
            case 9:
                color = "#4caf50"; //blue
                break;
            case 10:
                color = "#f30000"; //red
                break;
            default:
                color = ""; //no color
                break;

            //color = "#2196f3"  //blue
        }

        if (status === stateValue) {
            return color;
        } else {
            return "";
        }

        // if (status === stateValue) {
        //     return "#e44986";//colors.greenAccent[500];
        // } else {
        //     return "";//colors.primary[500];
        // }
    }

    function getColor(status) {
        if (status === stateValue) {
            if (status === 1) {
                return "#000000";
            } else {
                return "#ffffff";//colors.greenAccent[500];
            }

        } else {
            return "";//colors.primary[500];
        }


        // if (status === stateValue) {
        //     return "#ffffff";//colors.greenAccent[500];
        // } else {
        //     return "";//colors.primary[500];
        // }
    }

    function getBGColorFilter(current, filterValue) {
        if (current === filterValue) {
            //AXJO red: #e1251b
            //return "#e44986";//colors.greenAccent[500];
            return "#604F6B";
        } else {
            return "";//colors.primary[500];
        }
    }

    function getColorFilter(current, filterValue) {
        if (current === filterValue) {
            return "#ffffff";//colors.greenAccent[500];
        } else {
            return "";//colors.primary[500];
        }
    }

    // function getCustStatusSymbol(status) {
    //     let symbol = "";
    //     if (status !== 'OK') {
    //         symbol = "!"; //⚠️
    //     }
    //     return symbol;
    // }

    if (returnsQuery.isLoading || manufacturersQuery.isLoading || drumQualitiesQuerty.isLoading || reeltypesQuery.isLoading || articlesQuery.isLoading || rejectedReasonsQuery.isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img width="50px" height="50px" src="../../../assets/axion_spinner_white.gif" alt="ddd"></img></div>;
    }

    states.forEach((status) => {
        statesCount.push((returnsQuery.data?.filter(x => x.statusid === status).length) || 0);
    })

    // Borttagen för att det stör sökfunktionen
    if (returnsQuery.data?.length > 0) {
        if (searchValue === "" && (filteredData.length === 0 || filteredData === null)) {
            handleFilterState(2);
        }
    }

    //console.log("showdata ", showOrder);
    // console.log("returnsQuery.data", returnsQuery.data);

    //console.log("showOrder", showOrder);

    let orderLink = "";
    if (showOrder?.idHash !== null) {
        orderLink = "https://retur.axjo.com/orderinfo/" + showOrder?.idHash;
    }



    let content = <>

        {showSpinner &&
            // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'absolute', top: '15%', left: '50%' }}><img width="50px" height="50px" src="../../../images/axion_spinner_white.gif" alt="processing..."></img></div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1000', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                <span style={{ backgroundColor: "rgba(255, 255, 255, 1)", zIndex: '10', width: "150px", height: "150px", justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: '5px' }}>
                    <img width="50px" height="50px" src="../../../assets/axion_spinner_white.gif" alt="processing..."></img>
                </span>
            </div>

        }

        <Box color={colors.primary[100]}>

            {/* <Box>Total number of Returns {returnsQuery.data?.length}</Box> */}

            <Stack direction="row" width="100%" marginTop="1px" spacing="5px" marginLeft="25px" padding="x" display="flex" alignItems="center">

                {/* {states.map((status, index) => {
                    return (
                        // <Box>{stateNames[index]}</Box>

                        <Chip key={status} label={stateNames[index] + " (" + statesCount[index] + ")"} size='medium' onClick={() => handleFilterState(status)} sx={{ backgroundColor: getBGColor(status), color: getColor(status) }} />
                    )
                })} */}


                <Chip key={1} label={getStatusText(1) + " (" + statesCount[0] + ")"} size='medium' onClick={() => handleFilterState(1)} sx={{ backgroundColor: getBGColor(1), color: getColor(1) }} />
                {/* <Chip key={999} label={"Booked" + " (" + "0" + ")"} size='medium' onClick={() => handleFilterState(999)} sx={{ backgroundColor: getBGColor(999), color: getColor(999) }} /> */}
                <Chip key={3} label={getStatusText(3) + " (" + statesCount[2] + ")"} size='medium' onClick={() => handleFilterState(3)} sx={{ backgroundColor: getBGColor(3), color: getColor(3) }} />
                <Chip key={2} label={getStatusText(2) + " (" + statesCount[1] + ")"} size='medium' onClick={() => handleFilterState(2)} sx={{ backgroundColor: getBGColor(2), color: getColor(2) }} />
                <Chip key={9} label={getStatusText(9) + " (" + statesCount[4] + ")"} size='medium' onClick={() => handleFilterState(9)} sx={{ backgroundColor: getBGColor(9), color: getColor(9) }} />
                <Chip key={10} label={getStatusText(10) + " (" + statesCount[5] + ")"} size='medium' onClick={() => handleFilterState(10)} sx={{ backgroundColor: getBGColor(10), color: getColor(10) }} />
                {/* <Chip key={4} label={"Paid" + " (" + statesCount[3] + ")"} size='medium' onClick={() => handleFilterState(4)} sx={{ backgroundColor: getBGColor(4), color: getColor(4) }} /> */}


                <Box>
                    <Controls.Input
                        name="searchList"
                        label={formatMessage(messages.index_quickSearch)}
                        value={searchValue}
                        onChange={handleSearchChange}
                        //error={errors.name}
                        sx={{ marginLeft: '10px' }}
                        fullWidth={true}
                        autoComplete="new-password"
                        InputProps={{
                            endAdornment: (
                                <IconButton onClick={() => clearSearchValue("")}>
                                    {searchValue.length > 0 ? <ClearOutlinedIcon /> : ''}
                                </IconButton>
                            )
                        }}
                    />
                </Box>
                {/* <Box paddingLeft="10px">
                    <Tooltip title={<Typography fontSize="12px">Toggle cards to large view</Typography>}>
                        <IconButton onClick={() => toggleSlim(false)} > <ReorderOutlinedIcon /></IconButton>
                    </Tooltip>
                </Box> */}

                <Box paddingLeft="95px"></Box>
                <Box paddingLeft="5px" >
                    <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.index_sortByCustomer} /></Typography>}>
                        <IconButton onClick={() => sortByCustomer()}> <PeopleAltOutlinedIcon sx={{ color: sortBy === 'customer' ? '#f30000' : '' }} fontSize="large" /></IconButton>
                    </Tooltip>
                </Box>
                <Box paddingLeft="15px">
                    <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.index_sortByTransporter} /></Typography>}>
                        <IconButton onClick={() => sortByTransporter()} > <LocalShippingIcon sx={{ color: sortBy === 'transporter' ? '#f30000' : '' }} fontSize="large" /></IconButton>
                    </Tooltip>
                </Box>
                <Box paddingLeft="15px">
                    <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.index_sortByReturnpoint} /></Typography>}>
                        <IconButton onClick={() => sortByReturnpoint()} > <PlaceOutlinedIcon sx={{ color: sortBy === 'returnpoint' ? '#f30000' : '' }} fontSize="large" /></IconButton>
                    </Tooltip>
                </Box>

            </Stack>

            {distinctCustomers.length > 0 && <Stack direction="row" width="100%" marginTop="1px" spacing="5px" marginLeft="25px" display="flex" alignItems="center">
                {distinctCustomers.map((customer, index) => {
                    return (<Chip key={customer} label={customer} size='medium' onClick={() => filterByCustomer(customer)} sx={{ backgroundColor: getBGColorFilter(customer, customerFilter), color: getColorFilter(customer, customerFilter) }} />)
                })}
            </Stack>}

            {distinctTransporters.length > 0 && <Stack direction="row" width="100%" marginTop="1px" spacing="5px" marginLeft="20px" padding="5px" display="flex" alignItems="center">
                {distinctTransporters.map((transporter, index) => {
                    return (<Chip key={transporter} label={transporter} size='medium' onClick={() => filterByTransporter(transporter)} sx={{ backgroundColor: getBGColorFilter(transporter, transporterFilter), color: getColorFilter(transporter, transporterFilter) }} />)
                })}
            </Stack>}

            {distinctReturnpoints.length > 0 && <Stack direction="row" width="100%" marginTop="1px" spacing="5px" marginLeft="15px" padding="10px" display="flex" alignItems="center">
                {distinctReturnpoints.map((point, index) => {
                    return (<Chip key={point} label={point} size='medium' onClick={() => filterByReturnpoint(point)} sx={{ backgroundColor: getBGColorFilter(point, returnpointFilter), color: getColorFilter(point, returnpointFilter) }} />)
                })}
            </Stack>}

            <Divider color={colors.primary[900]} width="100%" marginLeft="25px" marginTop="10px" sx={{ marginLeft: '25px', marginTop: '10px' }} />

            <Grid container display="flex" alignItems="flex-start" width="100%" height="100%" direction="row" spacing="10px" padding="10px" >
                <Grid item xs={slim ? 3 : 12} lg={slim ? 2 : 8}>
                    <OrderList filteredData={filteredData} handleShowOrder={handleShowOrder} handleShowChildrenClick={handleShowChildrenClick} manufacturers={manufacturersQuery.data} slim={slim} showOrder={showOrder} sortBy={sortBy} handleShowCustomer={handleShowCustomer} />
                </Grid>

                <Grid item xs={slim ? 9 : 6} lg={slim ? 10 : 6}>

                    {showOrder !== null && <>
                        <Stack sx={{ width: '100%' }} ml="10px" direction="row" display="flex" alignContent="center" alignItems="center" spacing="40px">
                            <Box sx={{ borderBottom: 0, borderColor: 'divider', ml: '25px' }}>
                                <StyledTabs value={selectedTab} onChange={handleTabChange} aria-label="styled tabs example">
                                    <StyledTab label={formatMessage(messages.index_tabOrder)} />
                                    <StyledTab label={formatMessage(messages.index_tabDrums)} />
                                    <StyledTab label={formatMessage(messages.index_tabSupplier)} />
                                    {/* <StyledTab label={<Badge badgeContent={getCustStatusSymbol(showOrder?.customer?.status)} color="error">Supplier </Badge>}/> */}
                                </StyledTabs>
                            </Box>

                            <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="auto" paddingTop="10px" paddingBottom="10px" paddingRight="30px" marginLeft="10px" width="100%">
                                <Stack width="50%" spacing="20px" direction="row">
                                    {/* <Box><b><FormattedMessage {...messages.index_tabSupplier} />: {showOrder?.customer.customername}</b></Box> */}
                                    {/* {orderLink !== "" ? <Box><b><FormattedMessage {...messages.index_tabOrder} />: <a href={orderLink} target="_blank">{showOrder?.returnid}</a></b></Box> : <Box><b>Order: {showOrder?.returnid}</b></Box>} */}
                                </Stack>
                                <Box width="50%" display="flex" justifyContent="flex-end" paddingRight="0px">
                                    <Button
                                        sx={{
                                            width: "90px",
                                            backgroundColor: colors.dashbordGreen[500],
                                            "&:hover": {
                                                backgroundColor: colors.dashbordGreen[400],
                                                borderColor: "#5e7939",
                                                boxShadow: "none",
                                            },
                                            marginRight: "15px",
                                            // marginBottom: "15px",
                                        }}
                                        disabled={(showOrder?.customer?.status === "UNVERIFIED") || showOrder?.statusid === 9}
                                        onClick={() => handleSaveOrderClick()}
                                    ><SaveIcon />&nbsp;&nbsp;&nbsp;<FormattedMessage {...messages.index_btnSave} /></Button>
                                    {/* 
                                </Box>
                                <Box width="20%" display="flex" justifyContent="flex-end" paddingRight="28px"> */}
                                    <Button
                                        sx={{
                                            width: "90px",
                                            backgroundColor: "#f30000",
                                            "&:hover": {
                                                backgroundColor: colors.redAccent[400],
                                                borderColor: "#5e7939",
                                                boxShadow: "none",
                                            },
                                            //marginRight: "15px",

                                            // marginBottom: "15px",
                                        }}
                                        disabled={showOrder.statusid > 1}
                                        onClick={() => openCancelOrderDialogClick()}
                                    ><DoDisturbIcon />&nbsp;&nbsp;&nbsp;<FormattedMessage {...messages.index_btnCancel} /></Button>

                                </Box>
                                {/* <Box width="20%" display="flex" justifyContent="flex-end"><IconButton color="error" onClick={() => handleUpdateOrderClick()}><SaveIcon></SaveIcon></IconButton></Box> */}
                            </Stack>
                        </Stack>
                        {/* <Box width="98%" marginLeft="35px"><Divider color={colors.primary[900]} /></Box> */}
                    </>}

                    {showOrder !== null && <>
                        <Grid container display="flex" alignItems="flex-start" width="100%" height="100%" direction="row" spacing="10px" padding="0px" paddingTop="0px" marginLeft="0px">

                            {selectedTab === 2 && showCustomer !== null && <Grid item xs={12} lg={12}  >
                                <Box height="100%" padding="10px" backgroundColor={colors.primary[400]}>
                                    <CustomerInformation data={showCustomer} setShowCustomer={setShowCustomer} />
                                </Box>
                            </Grid>}

                            {selectedTab === 0 && <>
                                <Grid item xs={12} lg={6}  >
                                    <Box height="100%" padding="10px" backgroundColor={colors.primary[400]}>
                                        <BookingInformation data={showOrder} showHidden={showHidden} handleChange={handleChange} />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <Box height="100%" padding="10px" backgroundColor={colors.primary[400]}>
                                        <PickupDetails data={showOrder} showHidden={showHidden} handleChange={handleChange} handleChangeSetValue={handleChangeSetValue} addFreightCost={addFreightCost} />
                                    </Box>
                                </Grid>

                            </>}

                            {selectedTab === 1 && <>

                                {/* <Grid item xs={12}>
                                    <Box backgroundColor={colors.primary[400]} padding="10px">
                                        <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="auto" paddingTop="10px" paddingBottom="10px" paddingRight="30px" marginLeft="10px">
                                            <TextField id="outlined-basic" label="Created by" placeholder="Placeholder" variant="standard" defaultValue={" "} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                                            <TextField id="outlined-basic" label="Order comment" placeholder="???" variant="standard" multiline maxRows={3} defaultValue={" "} sx={{ width: '50%' }} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                                            <FormGroup>
                                                <FormControlLabel control={<Switch />} label="Public" />
                                            </FormGroup>
                                            <Button
                                                sx={{
                                                    backgroundColor: colors.dashbordGreen[500],
                                                    "&:hover": {
                                                        backgroundColor: colors.dashbordGreen[400],
                                                        borderColor: "#5e7939",
                                                        boxShadow: "none",
                                                    },
                                                    marginRight: "15px",
                                                    // marginBottom: "15px",
                                                }}>Add comment</Button>
                                        </Stack>

                                    </Box>
                                </Grid> */}
                                <Grid item xs={12}>
                                    <Box backgroundColor={colors.primary[400]} padding="10px">
                                        <DrumList
                                            key={showOrder?.returnDrums?.id}
                                            data={showOrder?.returndrums}
                                            manufacturers={manufacturersQuery.data}
                                            drumQualities={drumQualitiesQuerty?.data}
                                            reeltypes={reeltypesQuery?.data}
                                            articles={articlesQuery?.data}
                                            rejectedReasons={rejectedReasonsQuery?.data}
                                            handleRowChange={handleRowChange}
                                            handleDeliverRow={handleDeliverRow}
                                            handleDeliverReadyRows={handleDeliverReadyRows}
                                            handleDeleteRow={handleDeleteRow}
                                            handleAddRow={handleAddRow}
                                            splitRow={splitRow}
                                            handleCloseOrder={handleCloseOrder}
                                            status={showOrder.statusid}

                                        />
                                    </Box>
                                </Grid>
                            </>}
                        </Grid>

                    </>}
                </Grid>
            </Grid>
        </Box>

        <AxionConfirmation open={openConfirmation} title={confirmationTitle} message={confirmationMessage} onConfirm={handleCancelOrderClick} onCancel={cancelCancelOrderClick} cancelText="No" confirmText="Yes" />

    </>;

    return (
        <>
            {content}
        </>
    )
};

export default ReturnsIndex;

